module.exports = __webpack_public_path__ + "media/right-grey.2f42f543.svg";